// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bzzK","content":"styles_content__1ubGF","tableWrap":"styles_tableWrap__3ZbM8"};